import { render } from "./mfaModal.vue?vue&type=template&id=abd4b040"
import script from "./mfaModal.vue?vue&type=script&lang=js"
export * from "./mfaModal.vue?vue&type=script&lang=js"

import "./mfaModal.vue?vue&type=style&index=0&id=abd4b040&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__